import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelfAssessmentTemplate3RoutingModule } from './self-assessment-template3-routing.module';
import { SelfAssessmentTemplate3Component } from './self-assessment-template3.component';
import { SelfAssessmentDetailsComponent } from './self-assessment-details/self-assessment-details.component';
import { SelfAssessmentTemplate3OverallAssessmentComponent } from './self-assessment-template3-overall-assessment/self-assessment-template3-overall-assessment.component';
import { SummaryT3Component } from './summary-t3/summary-t3.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { SharedUIModule } from '../shared/shared-ui.module';
import {
  LucideAngularModule,
  Upload,
  File,
  Plus,
  Save,
  CircleOff,
  CheckCheck,
  Check,
  Star,
  CircleDot,
  Key
} from 'lucide-angular';
import { KeyInformationComponent } from './key-information/key-information.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { JudgmentT3Component } from './judgment-t3/judgment-t3.component';
import { InterpretationsT3Component } from './interpretations-t3/interpretations-t3.component';
import { DistributedUIModule } from '../distributed-ui-components/distributed-ui.module';
import { FrontComponent } from './shared-components/front/front.component';
import { ReviewComponent } from './shared-components/review/review.component';
import { ApprovalsComponent } from './shared-components/approvals/approvals.component';
import { ConditionalApprovalComponent } from './shared-components/conditional-approval/conditional-approval.component';
import { MatIconModule } from '@angular/material/icon';
import { ApproachT3Component } from './approach-t3/approach-t3.component';
import { SelfAssessmentRoutingComponentComponent } from './self-assessment-routing-component/self-assessment-routing-component.component';



@NgModule({
  declarations: [
    SelfAssessmentTemplate3Component,
    SelfAssessmentDetailsComponent,
    SelfAssessmentTemplate3OverallAssessmentComponent,
    SummaryT3Component,
    KeyInformationComponent,
    InterpretationsT3Component,
    JudgmentT3Component,
    FrontComponent,
    ReviewComponent,
    ApprovalsComponent,
    ConditionalApprovalComponent,
    ApproachT3Component,
    SelfAssessmentRoutingComponentComponent,
  ],
  imports: [
    CommonModule,
    SelfAssessmentTemplate3RoutingModule,
    MatDialogModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatInputModule,
    MatDatepickerModule,
    SelfAssessmentTemplate3RoutingModule,
    MatExpansionModule,
    AlertModule,
    BsDropdownModule,
    MatChipsModule,
    MatSelectModule,
    MatDialogModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatInputModule,
    MatDatepickerModule,
    SharedUIModule,
    FormsModule,
    CKEditorModule,
    MatDividerModule,
    LucideAngularModule.pick({
      Upload,
      File,
      Plus,
      Save,
      CircleOff,
      CheckCheck,
      Check,
      Star,
      CircleDot,
      Key
    }),
    DistributedUIModule,
    ReactiveFormsModule,
    MatIconModule,
  ],
  exports: [
    SelfAssessmentTemplate3Component,
    SelfAssessmentDetailsComponent,
    SelfAssessmentTemplate3OverallAssessmentComponent,
  ],
})
export class SelfAssessmentTemplate3Module {}
